import Image from '../../../api/Image';

export const store = async (context, {params}) => {
    return await new Image().store(params);
};

export default {
    store,
};



// WEBPACK FOOTER //
// ./src/store/modules/image/actions.js